import { Chip } from '@aibees/shared/components';
import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';
import usePriceAndPlanStore from '@aibees/shared/features/price-and-plan/store';
import { classnames } from '@aibees/shared/utils';
import { Button, CardContent } from '@mui/material';
import { memo, useEffect, useState } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ChangeDurationProps as Props } from './types';

enum DurationType {
  MONTHLY = 'Monthly',
  ANNUAL = 'Annually',
}

export const ChangeDuration = memo(
  ({ className, isDialogRightSide }: Props) => {
    const [yearly, setYearly] = usePriceAndPlanStore((s) => [
      s.yearly,
      s.setYearly,
    ]);
    const [activeDuration, setActiveDuration] = useState<DurationType>(
      yearly ? DurationType.ANNUAL : DurationType.MONTHLY
    );

    const { data: currentSub } = useCurrentSubscriptionApi();

    const handleChangeDuration = (duration: DurationType) => {
      setActiveDuration(duration);
      setYearly(duration === DurationType.ANNUAL);
    };

    useEffect(() => {
      if (currentSub?.current?.plan?.interval.toLowerCase() === 'year') {
        setYearly(true);
        setActiveDuration(DurationType.ANNUAL);
      }
    }, [currentSub, setYearly]);

    useEffect(() => {
      setYearly?.(activeDuration === DurationType.ANNUAL);
    }, [activeDuration, setYearly]);

    return (
      <Styled.Wrapper
        className={classnames('ChangeDuration', className)}
        sx={SX.root}
        variant="outlined"
      >
        <CardContent padding="normal" sx={SX.cardContent}>
          {Object.values(DurationType).map((value) => (
            <Button
              key={value}
              variant="contained"
              color={value === activeDuration ? 'primary' : 'inherit'}
              size="medium"
              onClick={() => handleChangeDuration(value)}
            >
              {value}
              {value === DurationType.ANNUAL && !isDialogRightSide && (
                <Chip
                  component="span"
                  label="Save 20%"
                  shape="rounded"
                  size="xsmall"
                  color="success"
                />
              )}
            </Button>
          ))}
        </CardContent>
      </Styled.Wrapper>
    );
  }
);

ChangeDuration.displayName = 'ChangeDuration';
